"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = (0, _screeners.expandscreeners)([{
  prompt: "Here are some common unhelpful thoughts. Choose one or you can write your own one to retrain.",
  type: "multiRadio",
  meta: {
    summaryTitle: "Your unhelpful thought was…"
  },
  options: ["I’m not good enough", "I’m a failure", "I’m ugly/fat", "I’m too disorganised", "I’m not going anywhere in life", "I’ve got too much work to do", "I’m ineffective and inefficient", "I don’t know what to do", "Other"],
  batteryId: "RETRAINING_THINKING_REVISION"
}, {
  prompt: "Choose any of the following that apply to your thought and write any additional ones down. The cost of believing my unhelpful thought is that it makes me...",
  type: "multiRadio",
  meta: {
    summaryTitle: "The main costs of that thought are:"
  },
  options: ["Feel bad (eg: overwhelmed or depressed or anxious etc)", "Feel resentful or start blaming other people or situations", "Unproductive or hard to concentrate/focus", "Feel like not trying and giving up", "Feel like I have to hide who I am from others because it’s bad", "Act in ways that I don’t want to, which makes me feel guilty", "Get angry, grumpy or defensive with others", "Treat myself badly", "Go into an autopilot mode where I feel numb and lifeless", "Lose confidence or feel incapable", "Procrastinate", "Feel physical feelings like muscle tension or feeling sick", "Feel less than others or compare myself to others", "Other"],
  batteryId: "RETRAINING_THINKING_REVISION"
}, {
  prompt: "Here are some general reasons of why your thought might not be 100% true so choose any of the following. My thought isn’t 100% true because…",
  type: "multi",
  meta: {
    answerLabel: "My thought isn’t 100% true because",
    summaryTitle: "The reasons why the thought isn’t 100% true are:"
  },
  options: ["There are times when the opposite is just as true", "Someone has said or done something that means the thought can’t be totally true", "Other people have told me reasons why it’s not true and I partly believe them", "I have strengths that prove this thought isn’t always true", "There are genuine reasons why things are likely to work out ok", "When I don’t believe my unhelpful thought I act differently", "I’ve overcome similar problems in the past (even when I thought I couldn’t)"],
  batteryId: "RETRAINING_THINKING_REVISION"
}, {
  prompt: "Thanks for that. Those were general reasons. However, this exercise only really works when you can come up with a reasons that feel true for you personally. So what are the main reasons for you?",
  type: "textarea",
  meta: {
    answerLabel: "My thought isn’t 100% true because…",
    summaryTitle: "The reasons why the thought isn’t 100% true are:"
  },
  batteryId: "RETRAINING_THINKING_REVISION"
}, {
  prompt: "Thanks for taking the time to write that. It can help to write a new, helpful thought that you can use whenever the old, unhelpful thought comes up again. What would your new thought be to replace the old one?",
  type: "textarea",
  meta: {
    answerLabel: "The thought is...",
    summaryTitle: "Your new thought to replace the old thought is:"
  },
  batteryId: "RETRAINING_THINKING_REVISION"
}, {
  prompt: "If you still feel like your unhelpful thought is true then write down the reasons why it still feels true. These are next thoughts that we’d recommend retraining and you can access a secure reminder about them later on.",
  type: "textarea",
  meta: {
    answerLabel: "My unhelpful thought still feels true because…",
    summaryTitle: "Your next thought(s) to retrain are:"
  },
  batteryId: "RETRAINING_THINKING_REVISION"
}, _utils.screeners.HELPFUL]);
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;